import { useInfiniteQuery } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import useGetOffering from './useGetOffering';
import { getOfferingUpdates } from 'services/offerings';

const usePaginatedOfferingUpdatesService = ({ getAll, recentlyApproved, slug }) => {
  const searchParams = useSearchParams();

  const privateUpdateToken = searchParams?.get('private_update_token');
  const { data: offeringData } = useGetOffering({ slug });

  const { data, isFetching, isFetchingNextPage, fetchNextPage, hasNextPage, isError, isSuccess } =
    useInfiniteQuery({
      queryKey: [
        'offeringUpdates',
        getAll ? 'all' : '',
        recentlyApproved ? 'new' : '',
        'campaignService',
      ],
      queryFn: ({ pageParam }) =>
        getOfferingUpdates({
          offeringId: offeringData?.primaryId,
          pageParam,
          size: getAll ? 10 : 100000,
          recentlyApproved,
          updateSelector: privateUpdateToken ? 'ALL' : 'PUBLIC',
        }),
      getNextPageParam: (lastPage) => {
        const { pageNumber, totalPages } = lastPage;
        return pageNumber < totalPages - 1 ? pageNumber + 1 : undefined;
      },
      refetchOnMount: false,
      refetchOnWindowFocus: true,
      enabled: !!offeringData?.primaryId,
    });

  const updateMap = recentlyApproved
    ? data?.pages?.[0].list?.reduce((map, update) => {
        map[update.id] = true;

        return map;
      }, {})
    : {};

  return {
    data,
    isError,
    isSuccess,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    updateMap,
  };
};

export default usePaginatedOfferingUpdatesService;
